<template>
  <b-jumbotron class="stripecontent">
    <b-row class="d-flex flex-row justify-content-center align-items-center">
      <b-col
        sm="2"
        v-for="(product, key) in products"
        v-bind:key="key"
        v-bind:style="{ backgroundImage: 'url(' + product.url + ')' }"
        class="box d-flex flex-column justify-content-center align-items-center"
        href="#"
      >
        <div class="description d-flex flex-column justify-content-center align-items-center">
          <h4>{{product.name}}</h4>
          <p>{{product.price}}</p>
        </div>
      </b-col>
    </b-row>
  </b-jumbotron>
</template>

<script>
export default {
  data() {
    return {
      products: [
        {
          name: 'Chicken Sukka',
          price: 'INR 150',
          url: 'https://gycommerce.s3.amazonaws.com/chicken-sukka.jpg',
        },
        {
          name: 'Fish Fry',
          price: 'INR 275',
          url: 'https://gycommerce.s3.amazonaws.com/fish-fry.jpg',
        },
        {
          name: 'Kari Roti',
          price: 'INR 75',
          url: 'https://gycommerce.s3.amazonaws.com/Kari+Roti.jpg',
        },
        {
          name: 'Chicken Tandoor',
          price: 'INR 400',
          url: 'https://gycommerce.s3.amazonaws.com/chicken-tandori.jpg',
        },
        {
          name: 'Mangalore Fish Curry',
          price: 'INR 275',
          url: 'https://gycommerce.s3.amazonaws.com/fish-curry.jpg',
        },
        {
          name: 'Chicken Tikka',
          price: 'INR 250',
          url: 'https://gycommerce.s3.amazonaws.com/chicken-tikka.jpeg',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.box {
  height: 50vh;
  background-color: white;
  background-size: cover;
  background-position: center center;
  padding: 0px 0px 0px 0px !important;
}
.box:hover {
  background-size: cover;
  background-position: center center;
}
.description {
  height: inherit;
  width: inherit;
  // color: rgba(0, 0, 0, 0);
  color: white !important;
  background-color: #1b1a1aad;
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}
.description:hover {
  color: white;
  background-color: #1b1a1aad;
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}
</style>
